import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Label, Input } from "./styles";

const UnstyledCheckbox = ({
    className,
    label,
    isChecked,
    onClick,
    onChange,
    isDisabled = false,
    inputValue,
    ariaLabel,
    otherCheckboxProps
}) => {
    inputValue = inputValue || label;

    return (
        <Label isDisabled={isDisabled} className={className}>
            <Input
                isDisabled={isDisabled}
                isChecked={isChecked}
                type="checkbox"
                value={inputValue}
                defaultChecked={isChecked}
                aria-disabled={isDisabled}
                aria-label={ariaLabel}
                onClick={() => {
                    if (isDisabled) return;
                    onClick(!isChecked);
                }}
                onChange={() => {
                    if (isDisabled) return;
                    if (onChange) onChange();
                }}
                {...otherCheckboxProps}
            />
            <span>{label}</span>
        </Label>
    );
};

const Checkbox = styled(UnstyledCheckbox)``;

Checkbox.propTypes = {
    label: PropTypes.any,
    isChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    inputValue: PropTypes.string,
    ariaLabel: PropTypes.string
};

export default Checkbox;
